import { formatNumberReverse } from '@/core/item_assistance/generatingDifferentialJson'

export function recursiveCalculations (expression, itemData, itemStructure, vm) {
	let node = vm.$math.parse(expression)
	let res = node.transform(function (node, path, parent) {
		if (node.isSymbolNode) {
			if (!itemStructure[node.name]) {
				return node
			} else if (itemStructure[node.name].hasOwnProperty('expression')) {
				let value = recursiveCalculations(itemStructure[node.name].expression, itemData, itemStructure, vm).evaluate()
				return new vm.$math.ConstantNode(Number(value))
			} else {
				let value = 0
				if (itemData[node.name]) {
					value = itemData[node.name].hasOwnProperty('val') ? formatNumberReverse(String(itemData[node.name].val), vm) : formatNumberReverse(String(itemData[node.name]), vm)
				}
				return new vm.$math.ConstantNode(Number(value))
			}
		} else {
			return node
		}
	})
	return res
}
